module.exports = __webpack_public_path__ + "img/yakor.adfa51d6.svg";